import moment from 'moment-timezone';
import type { WeeklyBreakdownReport, WeekDayKey } from 'model/BookingsWeeklyBreakdownReport';

export enum WeeklyBreakdownReportStatus {
    Initial = 'Initial',
    Getting = 'Getting',
    GettingSuccess = 'GettingSuccess',
    Error = 'Error'
}

const DAY_KEYS: WeekDayKey[] = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];

const emptyWeekValues = () => ({
    sun: 0,
    mon: 0,
    tue: 0,
    wed: 0,
    thu: 0,
    fri: 0,
    sat: 0,
    total: 0
});

const emptyCountPercentRow = () => ({
    values: {
        sun: { value: 0, pct: 0 },
        mon: { value: 0, pct: 0 },
        tue: { value: 0, pct: 0 },
        wed: { value: 0, pct: 0 },
        thu: { value: 0, pct: 0 },
        fri: { value: 0, pct: 0 },
        sat: { value: 0, pct: 0 }
    },
    total: 0
});

const emptyDays = () =>
    DAY_KEYS.reduce((acc, k) => {
        acc[k] = moment(0); // o moment() si prefieres "hoy"
        return acc;
    }, {} as Record<WeekDayKey, moment.Moment>);

export const emptyWeeklyBreakdownReport: WeeklyBreakdownReport = {
    weekStart: moment(0),
    weekEnd: moment(0),
    days: emptyDays(),

    totalBookings: emptyWeekValues(),
    bookingsPct: emptyWeekValues(),

    completed: emptyCountPercentRow(),
    canceled: emptyCountPercentRow(),
    noShow: emptyCountPercentRow(),

    totalPets: emptyWeekValues(),
    totalClients: emptyWeekValues(),

    netSales: emptyWeekValues(),
    salesPct: emptyWeekValues()
};

export interface WeeklyBreakdownReportState {
    report: WeeklyBreakdownReport;
    status: WeeklyBreakdownReportStatus;
    loading: boolean;
}
